var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMn9VwcisLofx90G(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07315 0.635726C9.13314 -0.214013 10.8626 -0.213366 11.9325 0.646468L18.8632 6.18651C19.6329 6.80653 20.1324 8.11586 19.9726 9.09569L18.6435 17.0556C18.4035 18.4655 17.0333 19.6257 15.6034 19.626H13.0028V10.8164C13.0028 9.71182 12.1074 8.81639 11.0028 8.81639H9.00284C7.89844 8.8166 7.00284 9.71195 7.00284 10.8164V19.626H4.40323C2.96323 19.626 1.60319 18.4756 1.36319 17.0556L0.0331107 9.09569C-0.13668 8.11573 0.363571 6.80642 1.14346 6.18651L8.07315 0.635726Z",
    fill: "#E873A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn9VwcisLofx90G);
export default __webpack_public_path__ + "static/media/mn9vwcis-lofx90g.b449a3dd4b8ac26e23da705b3e2ed827.svg";
export { ForwardRef as ReactComponent };